import { message } from 'antd'
import axios from 'axios'
import { getAuth, getIdToken } from 'firebase/auth'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export const useGetCareerObjectives = ({ employeeUid }) => {
  return useQuery(
    ['careerObjectives', employeeUid],
    async () => axios.get(
      `${process.env.REACT_APP_API_URL}/talent/employees/${employeeUid}/careerObjectives`,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser, true)}`,
          'X-Tenant-Id': process.env.REACT_APP_TENANT_ID
        }
      }
    )
      .then(res => res.data.data),
    {
      staleTime: 1000 * 60 * 5,
      enabled: !!employeeUid,
      retry: false,
      onError: (error) => {
        message.error(`Failed to fetch career objectives: ${error.response.data.message}`)
      }
    }
  )
}

export const useUpdateCareerObjectives = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (body) => axios.put(
      `${process.env.REACT_APP_API_URL}/talent/employees/${body.employeeUid}/careerObjectives`,
      body.data,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser, true)}`,
          'X-Tenant-Id': process.env.REACT_APP_TENANT_ID
        }
      }
    )
      .then(res => res.data),
    {
      onSuccess: () => {
        message.success('Successfully updated career objectives')
        queryClient.invalidateQueries('employee')
      },
      onError: (error) => {
        message.error(`Failed to update career objectives: ${error.response.data.message}`)
      }
    }
  )
}
